






















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { processServe } from '@/api/installServer';
@Component({
  components: {},
})
export default class BranchCondition extends Vue {
  private visible = false;

  formData: any = {
    number: '202108200937000290531',
    name: '张三',
    company: '杭州祺云科技有限公司',
    department: '技术部',
    makeUpCardShift: '2021/08/20，星期五，中班，下班时间18:00',
    makeUpCardTime: '2021-8-20 18:00',
    makeUpCardReason: '补卡路由',
    approvalComments: '同意',
    agreeList: ['王武', '臧三', '李斯'], // 同意人员列表
    imgList: ['https://img2.baidu.com/it/u=1969982897,3857962108&fm=26&fmt=auto&gp=0.jpg', 'https://img0.baidu.com/it/u=1625981895,2179496145&fm=26&fmt=auto&gp=0.jpg'], // 图片列表
    fileList: [
      {
        fileName: '文件名.后缀1',
        fileSize: '5.93MB',
      },
      {
        fileName: '文件名.后缀2',
        fileSize: '5.93MB',
      },
    ],
    processList: [
      {
        type: 0,
        processTitle: '发起申请',
        processName: '张三',
        processTime: '08/23 08:56',
      },
      {
        type: 1,
        processTitle: '直接主管',
        processName: '李四',
        processTime: '08/24 08:56',
      },
      {
        type: 2,
        processTitle: '间接主管',
        processName: '王五',
        processTime: '08/25 08:56',
      },
    ],
  };

  colorList = ['#4C64FE', '#32C5FF', '#6236FF'];
  form: any = {};
  flowDataHandle: any = {};

  getFlowLog(item: any) {
    processServe
      .getFlowExampleLog(item.id)
      .then((res: any) => {
        console.log(res.data);
        this.formData.processList = res.data;
      })
      .catch((e: any) => {});
  }

  private async showDrawer(form: any, flowDataHandle: any) {
    this.getFlowLog(form);
    this.form = form;
    this.flowDataHandle = flowDataHandle;
    this.visible = true;
  }

  handleClose() {
    this.visible = false;
  }
}
